/**
 * Variant Combinations Builder
 * availableVariantCombinationsを構築
 */

(function() {
  'use strict';

  /**
   * availableVariantCombinationsを構築
   * @param {Array} variants - 全バリアント配列
   * @param {Array} shopifyOptions - Shopifyオプション定義
   * @param {Array} priceData - 価格データ配列（オプション）
   * @returns {Object} - availableVariantCombinations
   */
  function buildVariantCombinations(variants, shopifyOptions, priceData = []) {
    if (!Array.isArray(variants) || !Array.isArray(shopifyOptions)) {
      console.warn('[Variant Combinations Builder] Invalid input');
      return {
        byPaper: {},
        byPrintColor: {},
        withPriceByPaper: {},
        withPriceByPrintColor: {}
      };
    }

    // 全バリアントから条件を抽出
    const extracted = window.extractConditionsFromVariants(variants, shopifyOptions);
    
    // 正規化関数
    const normalize = window.normalizeString || ((str) => str);
    
    // Shopifyオプション値のリストを取得（印刷色数）
    const printColorOpt = shopifyOptions.find(opt => opt.name === '印刷色数');
    const shopifyPrintColorOptions = printColorOpt?.values || [];
    const normalizedShopifyColors = shopifyPrintColorOptions.map(opt => ({
      original: opt,
      normalized: normalize(opt)
    }));
    
    // 全バリアントベースのマッピング（表示用）
    const combinationsByPaper = {};
    const combinationsByPrintColor = {};
    
    // 全バリアントから組み合わせを構築
    Object.entries(extracted.byPaper).forEach(([paper, printColors]) => {
      combinationsByPaper[paper] = printColors.map(extractedColor => {
        // 正規化してShopifyオプション値とマッチ
        const normalizedExtracted = normalize(extractedColor);
        const matchingOption = normalizedShopifyColors.find(opt => 
          normalize(opt.original) === normalizedExtracted
        );
        // Shopifyオプション値があればそれを使用、なければ抽出した値をそのまま使用
        return matchingOption ? matchingOption.original : extractedColor;
      });
      
      // Shopifyオプションの順序でソート
      if (shopifyPrintColorOptions.length > 0) {
        combinationsByPaper[paper].sort((a, b) => {
          const indexA = shopifyPrintColorOptions.indexOf(a);
          const indexB = shopifyPrintColorOptions.indexOf(b);
          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });
      }
    });
    
    Object.entries(extracted.byPrintColor).forEach(([printColor, papers]) => {
      combinationsByPrintColor[printColor] = papers;
    });
    
    // 価格データがある組み合わせのみのマッピング（価格表表示用）
    const withPriceByPaper = {};
    const withPriceByPrintColor = {};
    
    // 価格データから組み合わせを構築
    if (Array.isArray(priceData) && priceData.length > 0) {
      const uniqueVariationCodes = [...new Set(priceData.map(p => p.variation_code).filter(Boolean))];
      
      uniqueVariationCodes.forEach(code => {
        if (!code || code === '標準') return;
        
        const parts = code.split('_');
        if (parts.length >= 2) {
          const paper = parts[0];
          const extractedPrintColor = parts.slice(1).join('_');
          
          // 正規化してShopifyオプション値とマッチ
          const normalizedExtracted = normalize(extractedPrintColor);
          const matchingOption = normalizedShopifyColors.find(opt => 
            normalize(opt.original) === normalizedExtracted
          );
          const printColor = matchingOption ? matchingOption.original : extractedPrintColor;
          
          if (!withPriceByPaper[paper]) {
            withPriceByPaper[paper] = [];
          }
          if (!withPriceByPaper[paper].includes(printColor)) {
            withPriceByPaper[paper].push(printColor);
          }
          
          if (!withPriceByPrintColor[printColor]) {
            withPriceByPrintColor[printColor] = [];
          }
          if (!withPriceByPrintColor[printColor].includes(paper)) {
            withPriceByPrintColor[printColor].push(paper);
          }
        }
      });
      
      // Shopifyオプションの順序でソート
      Object.keys(withPriceByPaper).forEach(paper => {
        if (shopifyPrintColorOptions.length > 0) {
          withPriceByPaper[paper].sort((a, b) => {
            const indexA = shopifyPrintColorOptions.indexOf(a);
            const indexB = shopifyPrintColorOptions.indexOf(b);
            if (indexA === -1 && indexB === -1) return 0;
            if (indexA === -1) return 1;
            if (indexB === -1) return -1;
            return indexA - indexB;
          });
        }
      });
    }
    
    return {
      // 全バリアントベース（表示用）
      byPaper: combinationsByPaper,
      byPrintColor: combinationsByPrintColor,
      // 価格データがある組み合わせのみ（価格表表示用）
      withPriceByPaper: withPriceByPaper,
      withPriceByPrintColor: withPriceByPrintColor
    };
  }

  // グローバルに公開
  window.buildVariantCombinations = buildVariantCombinations;

})();

